<dx-select-box #selectBox
               displayExpr="name"
               valueExpr="id"
               [dataSource]="verbs"
               [disabled]="loading"
               [readOnly]="readonly"
               [value]="selectedItem"
               (selectedItemChange)="onSelectedItemChange($event)">
</dx-select-box>
